<template>
  <div class="msg-robot" ref="msgRobot">
    <span v-show="isTyping" class="typing-placehold">{{
      $t('common_typing')
    }}</span>
    <div v-show="!isTyping">
      <!-- 消息体 -->
      <div class="msg-robot-bd">
        <!-- 核心内容 -->
        <div
          ref="msgContent"
          class="msg-content"
          :class="contentFold ? 'content-fold' : ''"
        >
          <!-- 这里2的情况不要全等，后端server的类型变来变去的 -->
          <qlist-msg v-if="data.content.type == 2" :message="data"></qlist-msg>
          <free-msg v-if="data.content.type === 4" :message="data"></free-msg>
          <html-msg v-if="data.content.type === 5" :message="data"></html-msg>
          <batch-msg v-if="data.content.type === 6" :message="data"></batch-msg>
          <model-msg v-if="data.content.type === 7" :message="data"></model-msg>
        </div>
        <!-- 折叠后的查看更多 -->
        <div v-if="contentFold" class="unfold-cnt-btn" @click="unfold">
          <span>{{ $t('chat_graphic_msg_viewdmore_text') }}</span>
          <div class="arrow-down-box">
            <img class="arrow-down icon-primay" src="./assets/arrow-down.svg" />
          </div>
        </div>
      </div>
      <!-- 满意度 -->
      <div v-if="showVote" class="vote-box">
        <div v-if="voteData.active">
          <span
            class="vote-icon active"
            :class="'vote-icon-' + voteData.active"
          ></span>
        </div>
        <div v-else>
          <span
            v-for="item in voteData.button"
            :key="item.key"
            class="vote-icon"
            :class="'vote-icon-' + item.key"
            @click="doVote(item)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalWin from '@/utils/globalWin';
import { htmlDecimalDecode } from '@/utils/htmlDecode';
import bindlLinkClick from '@/utils/bindlLinkClick';
import viewHtmlImg from '@/utils/viewHtmlImg';
import qs from 'qs';
import { getScrollBottom, scrollLimit } from '@/utils/scroll.ts';

import components from './robot-sub-msg/require-all-robot-msg.js';
import { IMSDK } from '@/imsdk/index.ts';
const imsdk = IMSDK.create();

export default {
  inject: ['globalData', 'wpaDetail', 'switchMsgDisplay', 'to'],
  components: {
    ...components,
  },
  props: {
    data: Object,
  },
  data() {
    // 获取满意度信息
    const voteData = this.data.content.vote;
    const tags = imsdk.getMessageTags(this.data);
    const savedData = tags.find(item => item.tag === 'satisfaction');
    if (savedData) {
      try {
        Object.assign(voteData, JSON.parse(savedData.value));
      } catch (ex) {}
    }

    return {
      // 消息是否过长折叠了
      contentFold: false,
      // 是否已完成输入动画
      typingFinished: false,
      // 计时器
      typingTimer: null,
      voteData,
    };
  },
  computed: {
    /**
     * 是否显示正在输入状态
     * 注意，机器人的延迟输入逻辑和人工输入状态的逻辑是不一样的：
     * 机器人是先收到消息后才显示的【假输入状态】，在一段时间后替换为真的逻辑。
     * 人工输入是收到 typing 时间后显示状态，收到消息后再因此此状态。
     * 所以：机器人的输入状态是集成到robotMsg中的，而人工输入typing是当作一个【独立特殊的消息体】来处理
     */
    isTyping() {
      const { robotDelay } = this.globalData;
      // 是否历史漫游消息 && 开关 && 是否当前消息 && 是否已经结束输入
      return (
        !this.data.fromHisotry
        && robotDelay.switch
        && robotDelay.current === this.data.seq
        && !this.typingFinished
      );
    },

    // 是否显示单项满意度
    showVote() {
      // 监测是否禁止了【不满意度功能】
      if (this.globalData.robotMsgSetting && this.globalData.robotMsgSetting.disabledVote) {
        return false;
      }
      const { time, content } = this.data;
      console.log('[vote]', content.vote);
      if (!content.vote) {
        return false;
      }
      const { expiredIntervalTime } = content.vote;

      // 是否过期，如果时间过期则不显示满意度功能
      return !this.contentFold && (Date.now() - time < expiredIntervalTime);
    },

    // 该条消息的机器人id
    msgRobotid() {
      try {
        const extData = this.data.crm.msg_webim_extra_data;
        const robotId = extData.uint64_robotid;
        return robotId;
      } catch (ex) {
        return 0;
      }
    },
  },

  watch: {
    'globalData.robotDelay.current': {
      handler(val) {
        // 如果值变化了（有新消息进来），就停止当前计时。
        if (val !== this.data.seq) {
          clearTimeout(this.typingTimer);
          this.typingFinished = true;
          this.switchMsgDisplay(this.data.seq, 'show');
        }
      },
      deep: true,
    },

    isTyping() {
      // 输入状态消失后，要重新判断
      this.$nextTick(() => {
        // 如果是【输入】状态，则不判断
        if (!this.isTyping) {
          this.checkIfNeedFold();
          globalWin.scrollToBottom();
        }
      });
    },
  },

  mounted() {
    this.globalData.robotDelay.current = this.data.seq;
    // 开始输入态倒计时
    const time = this.getDelayTime();
    this.typingTimer = setTimeout(() => {
      this.typingFinished = true;
      this.switchMsgDisplay(this.data.seq, 'show');
    }, time * 1000);

    this.$nextTick(() => {
      // 监测是否需要折叠内容
      // 如果是【输入】状态，则不判断
      if (!this.isTyping) {
        this.checkIfNeedFold();
      }

      // 处理消息中的a点击
      this.handleContentClick();
    });
  },

  methods: {
    checkIfNeedFold() {
      // 检测是否关闭了【内容折叠】功能
      if (this.globalData.robotMsgSetting && this.globalData.robotMsgSetting.disabledFold) {
        return;
      }
      if (this.isNoSupportFold()) {
        return;
      }
      const cntBox = this.$refs.msgContent;
      let cntHeight = cntBox.offsetHeight;

      const imgs = cntBox.querySelectorAll('img');
      imgs.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.onload = () => {
          cntHeight = cntBox.offsetHeight;
          this.refreshFoldState(cntHeight);
          this.onLoad();
        };
      });

      this.refreshFoldState(cntHeight);
      this.onLoad();
    },
    // 是否支持消息内容折叠
    isNoSupportFold() {
      // 机器人电商消息，不支持内容折叠
      return this.data.content.type === 7;
    },

    /**
     * 计算内容区高度
     */
    refreshFoldState(cntHeight) {
      const foldHeight = 320; // 注意要和css中的一致

      if (cntHeight >= foldHeight) {
        this.contentFold = true;
      } else {
        this.contentFold = false;
      }
    },

    /**
     * 展开
     */
    unfold() {
      this.contentFold = false;
    },

    // 满意度点击
    doVote(item) {
      const { key } = item;

      const type = key === 'up' ? '1' : '0';
      // 保存数据
      const { kfuin } = this.wpaDetail;
      const url = `/cl/robotSatisfaction/robotReport?kfuin=${kfuin}`;
      const data = {
        kfuin,
        visitid: this.to.user_id,
        robotid: this.msgRobotid,
        seq: this.voteData.id,
        type,
      };

      this.$ajax.post(url, qs.stringify(data), { headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      } })
        .then((res) => {
          const rs = res.data;
          if (rs.r === 0) {
            this.$set(this.voteData, 'active', key);
            this.storeDateToMsg({ active: key });
          } else {
            console.log('[robot-msg-vote-fail]', rs);
          }
        })
        .catch((err) => {
          console.log('[robot-msg-vote-error]', err);
        });
    },

    /**
     * 将用户评价数据存储到消息用，用于回显
     */
    storeDateToMsg(data) {
      console.log('[storeDateToMsg]', data);
      imsdk.setMessageTags(this.data, [{
        tag: 'satisfaction',
        value: JSON.stringify(data),
      }]);
    },

    // 计算延迟时间
    getDelayTime() {
      const robotDelayTime = this.globalData.robotDelay.time;
      const wordNum = this.getDelayWord();
      if (wordNum <= 30) {
        return (robotDelayTime / 4).toFixed(1);
      }
      if (wordNum <= 100) {
        return (robotDelayTime / 2).toFixed(1);
      }
      if (wordNum <= 300) {
        return ((robotDelayTime / 4) * 3).toFixed(1);
      }
      return robotDelayTime;
    },

    // 计算延迟消息长度
    getDelayWord() {
      const msgData = this.data.content;
      let msgContent;
      if (msgData.type === 4 || msgData.type === 5) {
        msgContent = msgData.content || '';
      } else if (msgData.type === 6) {
        msgContent = msgData.answer.content || '';
      }
      msgContent = htmlDecimalDecode(msgContent);
      const wordLength = msgContent
        .replace(/<[^>]+>/g, '')
        .replace(/\[f_(.*?)\]/g, '').length;
      return wordLength;
    },

    /**
     * 处理点击事件
     */
    handleContentClick() {
      bindlLinkClick(this.$refs.msgRobot, '.msg-content a', {
        callback(link) {
          console.log('[link-click]', link);
        },
      });
      // 是否支持查看图片
      if (this.isNoSupportViewImag()) {
        return;
      }
      viewHtmlImg(this.$refs.msgRobot, '.msg-content img');
    },

    // 是否不支持预览图片
    isNoSupportViewImag() {
      // 机器人电商消息，不支持图片预览
      return this.data.content.type === 7;
    },

    /**
     * load处理
     */
    onLoad() {
      // 滚动
      if (getScrollBottom() < scrollLimit) {
        globalWin.scrollToBottom(true, 500);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.msg-robot {
  box-sizing: border-box;
  padding: 10px 15px;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  max-width: 300px;

  .msg-content{
    ::v-deep img{
      max-width: 100%;
    }
  }

  .content-fold {
    max-height: 320px;
    overflow: hidden;
  }

  // 正在输入
  .typing-placehold {
    color: #a8abb3;
  }

  // 查看更多
  .unfold-cnt-btn {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    font-size: 13px;
    color: @primary;
    cursor: pointer;
    background: #fff;
    border-radius: 2px 6px 6px 6px;
    .arrow-down-box{
      width: 13px;
      height: 13px;
      overflow: hidden;
      margin-left: 4px;
      line-height: 0;
    }
    .arrow-down {
      width: 100%;
      height: 100%;

      filter: drop-shadow(@primary -24px 0px 0px);
      transform: translateX(24px);
    }
  }

  // 单条消息满意度
  .vote-box {
    position: absolute;
    left: 100%;
    bottom: 0;
    margin-left: 5px;

    // H5: 默认白底灰图；PC：默认灰底白图；
    // hover: 均为蓝底白图
    // 选择后 .acitve: 均为透明底灰图
    .vote-icon {
      display: block;
      margin-top: 8px;
      width: 22px;
      height: 22px;
      cursor: pointer;
      border-radius: 50%;

      transition: all 0.15s cubic-bezier(0.36, 0.01, 0.1, 1) 0s;

      // 默认样式：白底灰图加阴影
      background: #fff url('~./assets/vote-down.svg') no-repeat center;
      background-size: 14px;
      box-shadow: 0px 0px 1px rgba(18, 19, 25, 0.08),
        0px 0px 2px rgba(18, 19, 25, 0.08),
        0px 2px 4px rgba(18, 19, 25, 0.08);

      // 点赞
      &.vote-icon-up {
        background-image: url('~./assets/vote-up.svg');
      }

      // H5点击激活
      &:active:not(.active) {
        transform: rotate(60deg);
        transition: all 0.15s ease-out 0s;
        background-image: url('~./assets/vote-down-white.svg');
        background-color: #4A70FF !important;

        // 赞按钮
        &.vote-icon-up{
          background-image: url('~./assets/vote-up-white.svg');
        }
      }

      // 已点选
      &.active {
        background-image: url('~./assets/vote-down-white.svg');
        background-color: #4A70FF !important;
        pointer-events: none;

        // 点暂
        &.vote-icon-up{
          background-image: url('~./assets/vote-up-white.svg');
        }
      }
    }
  }
  &.pc.pc-not-frame {
    max-width: 460px;
  }
  // pc特殊样式
  &.pc {
    .unfold-cnt-btn {
      background: #f1f2f5;
    }

    .vote-box {
      .vote-icon {
        // 鼠标激活
        &:hover:not(.active) {
          transform: rotate(-30deg);
          transition: all 0.1s ease-in 0s;
        }
        // 点击
        &:active:not(.active) {
          transform: rotate(60deg);
          transition: all 0.15s ease-out 0s;
          background-image: url('~./assets/vote-down-white.svg');
          background-color: #4A70FF !important;

          // 赞按钮
          &.vote-icon-up{
            background-image: url('~./assets/vote-up-white.svg');
          }
        }
      }
    }
  }
}
</style>
